export function debounce(fn, delay) {
  var timer;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var context = this;
    var execute = function execute() {
      clearTimeout(timer);
      return fn.apply(context, args);
    };
    clearTimeout(timer);
    if (delay <= 0) {
      return execute();
    }
    return new Promise(function (resolve) {
      timer = setTimeout(function () {
        resolve(execute());
      }, delay);
    });
  };
}